module.exports = __webpack_public_path__ + "static/media/butter-robot-image-4.064baa32.jpg";